"use strict";
/**
 * Module convert fs functions to promise based functions
 */

var _regeneratorRuntime = require("/var/www/prod/lucky1/lucky-one-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/var/www/prod/lucky1/lucky-one-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.readFile = exports.writeFileSync = exports.writeFile = exports.read = exports.open = exports.close = exports.stat = exports.createReadStream = exports.pathExists = void 0;

var fs = require("fs");

exports.pathExists = fs.existsSync;
exports.createReadStream = fs.createReadStream;

function stat(_x) {
  return _stat.apply(this, arguments);
}

function _stat() {
  _stat = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(path) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", new Promise(function (resolve, reject) {
              fs.stat(path, function (err, stats) {
                if (err) reject(err);else resolve(stats);
              });
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _stat.apply(this, arguments);
}

exports.stat = stat;

function close(_x2) {
  return _close.apply(this, arguments);
}

function _close() {
  _close = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(fd) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", new Promise(function (resolve, reject) {
              fs.close(fd, function (err) {
                if (err) reject(err);else resolve();
              });
            }));

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _close.apply(this, arguments);
}

exports.close = close;

function open(_x3, _x4) {
  return _open.apply(this, arguments);
}

function _open() {
  _open = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(path, mode) {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", new Promise(function (resolve, reject) {
              fs.open(path, mode, function (err, fd) {
                if (err) reject(err);else resolve(fd);
              });
            }));

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _open.apply(this, arguments);
}

exports.open = open;

function read(_x5, _x6, _x7, _x8, _x9) {
  return _read.apply(this, arguments);
}

function _read() {
  _read = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(fd, buffer, offset, length, position) {
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt("return", new Promise(function (resolve, reject) {
              fs.read(fd, buffer, offset, length, position, function (err, bytesRead, _buffer) {
                if (err) reject(err);else resolve({
                  bytesRead: bytesRead,
                  buffer: _buffer
                });
              });
            }));

          case 1:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _read.apply(this, arguments);
}

exports.read = read;

function writeFile(_x10, _x11) {
  return _writeFile.apply(this, arguments);
}

function _writeFile() {
  _writeFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(path, data) {
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt("return", new Promise(function (resolve, reject) {
              fs.writeFile(path, data, function (err) {
                if (err) reject(err);else resolve();
              });
            }));

          case 1:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _writeFile.apply(this, arguments);
}

exports.writeFile = writeFile;

function writeFileSync(path, data) {
  fs.writeFileSync(path, data);
}

exports.writeFileSync = writeFileSync;

function readFile(_x12) {
  return _readFile.apply(this, arguments);
}

function _readFile() {
  _readFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(path) {
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt("return", new Promise(function (resolve, reject) {
              fs.readFile(path, function (err, buffer) {
                if (err) reject(err);else resolve(buffer);
              });
            }));

          case 1:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _readFile.apply(this, arguments);
}

exports.readFile = readFile;